import { useQuery } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useMessageVariableQueries() {
    const axiosPrivate = useAxiosPrivate();

    // Only list is allowed
    const messageVariableListQuery = useQuery({
        queryKey: ["message-variable", "list"],
        queryFn: () =>
            axiosPrivate
                .get("message-variable/")
                .then(r => r.data),
    });

    return {
        messageVariableListQuery,
    };
}
